/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Row, Col, FormGroup, FormFeedback, Label, Input, Button } from 'reactstrap'
import { Navigate } from 'react-router-dom'

import {AppContext} from '../AppContext';

class RecoverAccount extends React.Component
{
  redirectPauseSeconds = 5;
  redirectTimer = null;
  emailAddressElement = null;

  componentDidMount()
  {
    this.emailAddressElement.focus();
  }

  componentWillUnmount()
  {
    if (this.redirectTimer) clearTimeout(this.redirectTimer);
  }

  constructor(props)
  {
    super();

    this.state =
    {
      buttonsDisabled: true,
      emailAddress: '',
      emailAddressIsValid: undefined,
      emailAddressFB: null,
      recoveryEmailSent: false
    }

    this.setEmailAddress = this.setEmailAddress.bind(this);
  }

//LEFT OFF HERE need to rate limit the use of this function (look at use of resetPasswordMaxFrequencySeconds in Login.js)
//LEFT OFF HERE (also mind the TODO notes in Login.js about fail2ban and similar)
  async recover(action, event)
  {
    this.setState({ buttonsDisabled: true });

    event.preventDefault();

    var bodyData = {};
    bodyData.emailAddress = this.state.emailAddress;


    let url = ('username' === action ? 'recoverUsername' : 'sendPasswordResetToken')
    let service = ('username' === action ? 'icam' : 'dgBunker');

    let result = await this.context.dbTwig.callRestAPI(service, url, bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error recovering username/password');
    this.context.postNotification('success', 
      'If the information you have provided is valid then we have sent a recovery email.  If it does not arrive shortly, please check your Spam folder.');

    setTimeout(() => { this.redirectTimer = null; this.setState({recoveryEmailSent: true}); }, this.redirectPauseSeconds * 1000);
  }
  
  render()
  {
    if (this.state.recoveryEmailSent) return (<Navigate to={{pathname: '/login', replace: true}} />);

    return(
      <div>
        <h3 className="mx-auto">Username / Password Recovery</h3>
        <FormGroup row>
          <Label for="emailAddress" sm="2">Email Address</Label>
          <Col sm="3">
            <Row>
              <Input type="text" id="emailAddress" placeholder="Enter your email address"
                value={this.state.emailAddress} onChange={this.setEmailAddress}
                invalid={(undefined === this.state.emailAddressIsValid ? undefined : !this.state.emailAddressIsValid)} 
                valid={(undefined === this.state.emailAddressIsValid ? undefined : this.state.emailAddressIsValid)} 
                innerRef={(input) => this.emailAddressElement = input} 
              />
              <FormFeedback valid={false}>{this.state.emailAddressFB}</FormFeedback>
            </Row>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm="2" >
            <Button onClick={this.recover.bind(this, 'username')} disabled={this.state.buttonsDisabled} color="primary">Recover Username</Button>
          </Col>            
          <Col sm="2">
            <Button onClick={this.recover.bind(this, 'password')} disabled={this.state.buttonsDisabled} color="primary">Recover Password</Button>
          </Col>
        </FormGroup>
      </div>
    );
  }

  setEmailAddress(event)
  {
    let valid = true;
    let emailAddressFB = null;

    if (!window.isEmailAddressValid(event.target.value))
    {
      valid = false;
      emailAddressFB = "That does not look like a valid email address";
    }

    this.setState(
    { 
      emailAddress: event.target.value, 
      buttonsDisabled: !valid,
      emailAddressIsValid: valid,
      emailAddressFB: emailAddressFB
    });
  }
}

RecoverAccount.contextType = AppContext;

export default RecoverAccount